import * as React from "react";
const SvgCloudWired = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.5 15C12.5 16.3807 11.3807 17.5 10 17.5C8.61929 17.5 7.5 16.3807 7.5 15M12.5 15C12.5 13.6193 11.3807 12.5 10 12.5M12.5 15H17.5M7.5 15C7.5 13.6193 8.61929 12.5 10 12.5M7.5 15H2.5M10 12.5V10.8333M8 10C6.34315 10 5 8.71665 5 7.13355C5 5.82147 6 4.60938 7.5 4.375C7.97052 3.29627 9.08411 2.5 10.3829 2.5C12.0467 2.5 13.4065 3.7442 13.5 5.3125C14.383 5.68476 15 6.59838 15 7.58761C15 8.91993 13.8807 10 12.5 10L8 10Z",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgCloudWired;
